import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { TopHeaderComponent } from './components/layouts/top-header/top-header.component';
import { NavbarComponent } from './components/layouts/navbar/navbar.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { HomeComponent } from './components/pages/home/home.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { AboutComponent } from './components/pages/about/about.component';
import { GalleryComponent } from './components/pages/gallery/gallery.component';
import { LoginComponent } from './components/pages/login/login.component';
import { BlogTwoComponent } from './components/pages/blog/blog-two.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpErrorInterceptor } from './services/http-error.interceptor';
import { ResponseInterceptor } from './services/http-response.interceptor';
import { RouteConfig } from './route.config';
import { AuthGuard } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { UtilsService } from './services/utils.service';
import { HttpClientService } from './services/http-client.service';
import { HomeService } from './components/pages/home/home.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MediaServiceComponent } from './components/pages/media-service/media-service.component';
import { SportsServiceComponent } from './components/pages/sports-service/sports-service.component';
import { AdminBlogsComponent } from './components/pages/admin-pages/admin-blogs/admin-blogs.component';
import { AdminCourseComponent } from './components/pages/admin-pages/admin-course/admin-course.component';
import { AdminEventComponent } from './components/pages/admin-pages/admin-event/admin-event.component';
import { HomeLayoutComponent } from './components/layouts/content-layout/home-layout/home-layout.component';
import { AdminLayoutComponent } from './components/layouts/content-layout/admin-layout/admin-layout.component';
import { AdminNavbarComponent } from './components/layouts/content-layout/admin-layout/admin-navbar/admin-navbar.component';
import { AdminService } from './components/pages/admin-pages/admin.service';
import { JwtModule } from '@auth0/angular-jwt';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

export function tokenGetter() {
  return localStorage.getItem('token');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeLayoutComponent,
    AdminLayoutComponent,
    AdminNavbarComponent,
    PreloaderComponent,
    HomeComponent,
    TopHeaderComponent,
    NavbarComponent,
    FooterComponent,
    ContactComponent,
    AboutComponent,
    GalleryComponent,
    LoginComponent,
    BlogTwoComponent,
    BlogDetailsComponent,
    ErrorComponent,
    MediaServiceComponent,
    SportsServiceComponent,
    AdminBlogsComponent,
    AdminCourseComponent,
    AdminEventComponent,
    PrivacyPolicyComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    JwtModule.forRoot(
      {
        config: {
          tokenGetter: tokenGetter,
          skipWhenExpired: true
        }
      }
    )
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResponseInterceptor,
      multi: true
    },
    HttpClientService,
    RouteConfig,
    AuthGuard,
    AuthService,
    UtilsService,
    HomeService,
    AdminService,
    provideClientHydration()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
